<template>
  <Modal :show-modal="showSelectFolderModal" @close="toggleSelectFolderModal">
    <template #header>
      <TitleSmall :title="$t('folders.select.title')" />
    </template>
    <template #body>
      <div class="folders">
        <div
          v-for="(folder, index) in allFolders"
          :key="index"
          class="folder"
          @click="selectFolder(folder)"
        >
          <div class="folder__header">
            <div class="folder__header--icon">
              <i class="fas fa-folder" />
            </div>
          </div>
          <div class="folder__body">
            <TextRegular bold>
              {{ folder.attributes.name }}
            </TextRegular>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup>
import TextRegular from '@/components/shared/font/text/TextRegular'
import TitleSmall from '@/components/shared/font/title/TitleSmall'
import Modal from '@/components/shared/Modal'
import i18n from '@/i18n'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t

const projectId = computed(() => store.state.workspace.projectId)
const allFolders = computed(() => store.state.folder.allFolders)
const showSelectFolderModal = computed(
  () => store.state.modals.showSelectFolderModal
)

const addProjectToFolder = (payload) =>
  store.dispatch('workspace/addProjectToFolder', payload)
const toggleSelectFolderModal = () =>
  store.commit('modals/toggleSelectFolderModal')

async function selectFolder(folder) {
  let data = {
    projectId: projectId.value,
    folderName: folder.attributes.name,
    folderId: folder.id
  }
  await addProjectToFolder(data)
  toggleSelectFolderModal()
}
</script>
<style lang="scss" scoped>
.modal-mask {
  :deep(.modal-container) {
    padding: 20px !important;
  }
  .folders {
    .folder {
      width: 270px;
      border: 1px solid $black-30;
      border-radius: 5px;
      padding: 0.3rem 0.5rem 0.1rem 0.5rem;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      cursor: pointer;
      margin-bottom: 0.7rem;

      @include mobileLandscape {
        width: 350px;
      }
      @include desktop {
        width: 500px;
      }
      @include desktopExtraLarge {
        width: 650px;
      }

      &:hover {
        border-color: $blue-80;
      }

      &__header {
        margin-right: 1rem;
        width: 24px;
        &--icon {
          .fas {
            color: $blue-80;
            opacity: 0.8;
            font-size: 24px;
          }
        }
      }

      &__body {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        overflow: hidden;

        .text {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
